const ticketCarousel = document.querySelector(".js-ticket-Carousel");

if (typeof ticketCarousel != "undefined" && ticketCarousel != null) {

    const nextButton = ticketCarousel.querySelector(".js-carousel-next"),
    prevButton = ticketCarousel.querySelector(".js-carousel-prev"),
    dateBtns = ticketCarousel.querySelectorAll(".js-date-btn"),
    monthBtns = document.querySelectorAll(".js-month-btn"),
    monthLabels = document.querySelectorAll(".js-month-label"),
    ticketList = document.querySelector(".js-ticket-list");
    

    var $ticketListDestination = jQuery("#ticket-list-destination"),
        ticketLoader = jQuery("#ticketLoader");
   
    let activeBtn = 0, btnIndex = 0, isDragging = false, mnthIndex = 0, btnType, selectedCell = 0, cellJump = 0;

    if (width < 600) {
        cellJump = 2;
    } else {
        cellJump = 6;
    }

    let flkty = new Flickity(ticketCarousel, {
        cellAlign: "center",
        cellSelector: ".date-picker__slide",
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        groupCells: 1
    });

    nextButton.addEventListener("click", function () {
        let nextCell = flkty.selectedIndex + cellJump;
        if (nextCell >= flkty.cells.length) {
            nextCell = flkty.cells.length - 1;
        }
        flkty.selectCell( nextCell, false, false );
    });

    prevButton.addEventListener("click", function () {
        let prevCell = flkty.selectedIndex - cellJump;
        if (prevCell < 0) {
            prevCell = 0;
        }
        flkty.selectCell( prevCell, false, false );
    });

    // go to cell on click
    flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
        if ( !cellElement ) {
            return;
        }
        flkty.select( cellIndex)
    });


    // listen for dragging to disable click
    flkty.on( 'dragStart', function( event, pointer ) {                
        isDragging = true;
    });

    flkty.on( 'pointerUp', function( event, pointer ) {
        setTimeout(function(){ 
            isDragging = false;
         }, 300);
    });

    
    dateBtns.forEach((btn) => {

        // find curently active cell
        if (btn.classList.contains('is-active')) {
            selectedCell = btn.dataset.index; 
        } 

        // btn click event
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            if (!isDragging) {
                gsap.to(ticketLoader, 0.3, { 
                    autoAlpha: 1, 
                    ease: Power1.easeInOut 
                });
                $ticketListDestination.empty();

                dateBtns[activeBtn].classList.remove('is-active');
                if (selectedCell != 0) {
                    dateBtns[selectedCell].classList.remove('is-active');
                }
                btnIndex = btn.dataset.index;
                activeBtn = btnIndex;
                btn.classList.add('is-active');

                let btnTicket = btn.dataset.ticket; 
                let ajaxURL = url + '/phpScripts/fetch-time-slots.php?venue=' + btnTicket;
                //console.log(ajaxURL);
                
                $ticketListDestination.load(ajaxURL + " #ajaxSource", function () {                    
                    gsap.to(ticketLoader, 0.3, { 
                        autoAlpha: 0, 
                        ease: Power1.easeInOut 
                    });

                    let btnDate = btn.dataset.date; 
                    let newURL = site + '/bookings?date=' + btnDate;
                    history.pushState({}, "", newURL);

                    let btnDateText = btn.dataset.datetext; console.log(btnDateText);
                    ticketList.textContent = btnDateText;
                }); 

            }
           
        });
    });

    // selected the selected cell
    flkty.selectCell( parseInt(selectedCell), false, true );


    
    // load slots from selected cell
    let firstCell = dateBtns[selectedCell];
    let firstVenueID = firstCell.dataset.ticket; 
    let ajaxURL = url + '/phpScripts/fetch-time-slots.php?venue=' + firstVenueID;
    
    $ticketListDestination.load(ajaxURL + " #ajaxSource", function () {
        gsap.to(ticketLoader, 0.3, { 
            autoAlpha: 0, 
            ease: Power1.easeInOut 
        });
    }); 


    // month btn event
    monthBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            btnType = btn.dataset.type; 

            monthLabels[mnthIndex].classList.remove("is-active");

            if (btnType == 'prev') {
                if (mnthIndex > 0) {
                    mnthIndex--;
                }
            } else {
                if (mnthIndex < 1) {
                    mnthIndex++;
                }
            }

            monthLabels[mnthIndex].classList.add("is-active"); // console.log(mnthIndex);

            if (mnthIndex == 0) {
                flkty.select( 0,false,false);
            } else {
                
                dateBtns.forEach((btn) => {
                    let btnMnthIndex = btn.dataset.mnth; //console.log(btnMnthIndex + ' / ' + btnMnthIndex);

                    if (btnMnthIndex == mnthIndex) {
                        btnIndex = btn.dataset.index;  console.log(btnIndex);
                        flkty.select(btnIndex,false,false);       
                    }
                });

            }

        });
    });

}
